import { render, staticRenderFns } from "./Perks.vue?vue&type=template&id=6e07116a&scoped=true&"
import script from "./Perks.vue?vue&type=script&lang=js&"
export * from "./Perks.vue?vue&type=script&lang=js&"
import style0 from "./Perks.vue?vue&type=style&index=0&id=6e07116a&scoped=true&lang=scss&"
import style1 from "./Perks.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../frontend-web/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e07116a",
  null
  
)

export default component.exports